import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '@core/services';

const TOKEN_KEY = environment.tokenKey;

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const storage = inject(StorageService);

  return from(storage.get(TOKEN_KEY)).pipe(
    switchMap((token) => {
      if (!request.url.includes(environment.apiBaseUrl)) {
        return next(request);
      }

      if (token) {
        request = request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + token),
        });
      }

      if (!request.headers.has('Content-Type')) {
        request = request.clone({
          headers: request.headers.set('Content-Type', 'application/json'),
        });
      }

      return next(request).pipe(
        map((event: HttpEvent<unknown>) => {
          return event;
        })
      );
    })
  );
};
